import { useSelector } from 'react-redux';

export function useExternalURL() {
    return useSelector((state) => state.ui.sidePanel.externalURL);
}
